export const ApiBatchRemoveSpaces = Symbol('ApiBatchRemoveSpaces');
